import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.solidIcon.background.disabled.primary(params);

export default primary;
